var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.41 20.985a.6.6 0 0 0 .348-.19.61.61 0 0 0 .133-.652c-.043-.113-.185-.255-3.838-3.8a653 653 0 0 1-3.794-3.696c0-.008 3.888-.018 8.638-.02l8.638-.006.09-.046c.28-.145.42-.414.362-.693a.64.64 0 0 0-.363-.459l-.089-.046-8.638-.005c-4.75-.003-8.638-.012-8.638-.02S5.967 9.68 8.053 7.655c3.693-3.585 3.795-3.685 3.84-3.804a.63.63 0 0 0-.5-.842.75.75 0 0 0-.398.048c-.097.043-8.836 8.502-8.912 8.626a.66.66 0 0 0-.017.612c.037.072 8.726 8.513 8.85 8.596a.63.63 0 0 0 .493.094",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;